import Header50_morph from './Header50_morph'
export default Header50_morph
